// @ts-nocheck



import React, { Component, Fragment } from 'react';
import styled, { css } from 'styled-components';
import clone from 'lodash/clone';





import RepairOrderVehicleEditRow from './RepairOrderVehicleEditRow';
import RepairOrderVehicleAddRow from './RepairOrderVehicleAddRow';
import { Icon as UiIcon } from '../../../components/ui';







/**
 * Компонент отображает список прикрепленных ТС для мойки
 */
class WashingOrderVehiclesForm extends Component {
  static defaultProps = {
    errors: [],
    vehicles: []
  };

  changeVehicle = (vehicle) => {
    const vehicles = [
    ...this.props.vehicles.filter(
      (vhcl) => vhcl.id !== vehicle.id
    ),
    vehicle];

    this.props.onChange(vehicles);
  };

  removeVehicle = (vehicle) =>
  this.props.onChange(
    this.props.vehicles.filter(
      (vhcl) => vhcl.id !== vehicle.id
    )
  );

  deleteOperation = (
  vehicleId,
  deleteOperation) =>
  {
    const vehicles = this.props.vehicles.map(
      (repairOrderVehicle) => {
        if (repairOrderVehicle.vehicleId === vehicleId) {
          const vehicle = clone(repairOrderVehicle, true);
          vehicle.operations = vehicle.operations.filter(
            (repairOrderOperation) =>
            repairOrderOperation.operationId !== deleteOperation.operationId
          );
          return vehicle;
        }
        return repairOrderVehicle;
      }
    );

    this.props.onChange(vehicles);
  };

  changeVehicleOperationCount = (
  vehicleId,
  updatedRepairOrderOperation) =>
  {
    const vehicles = this.props.vehicles.map(
      (repairOrderVehicle) => {
        if (repairOrderVehicle.vehicleId === vehicleId) {
          const vehicle = clone(repairOrderVehicle, true);
          vehicle.operations = vehicle.operations.map(
            (repairOrderOperation) => {
              if (
              repairOrderOperation.operationId ===
              updatedRepairOrderOperation.operationId)
              {
                return updatedRepairOrderOperation;
              }
              return repairOrderOperation;
            }
          );
        }
        return repairOrderVehicle;
      }
    );

    this.props.onChange(vehicles);
  };

  addVehicle = (vehicle) => {
    const existingVehicle = this.props.vehicles.find(
      (veh) => veh.id === vehicle.id
    );
    if (existingVehicle) {
      let updatedVehicle = { ...existingVehicle };
      vehicle.operations = vehicle.operations.map(
        (operation) => {
          const existingOperation = updatedVehicle.operations.find(
            (vehicleOperation) =>
            vehicleOperation.operation.id === operation.operation.id
          );
          if (existingOperation) {
            return {
              ...existingOperation,
              count: existingOperation.count + 1
            };
          }
          return {
            ...operation,
            count: 1
          };
        }
      );
      this.props.onChange([...this.props.vehicles, updatedVehicle]);
    } else {
      this.props.onChange([
      ...this.props.vehicles,
      {
        ...vehicle,
        operations: vehicle.operations.map(
          (operation) => ({
            ...operation,
            count: 1
          })
        )
      }]
      );
    }
  };

  render() {
    const { vehicles } = this.props;
    return (
      <Fragment>
        <Table>
          {vehicles.length > 0 &&
          <Header>
              <HeaderItem flex={1}>Виды работ</HeaderItem>
              <HeaderItem flex={1}>Количество</HeaderItem>
              <HeaderItem width={27} />
            </Header>
          }
          <Body>
            {vehicles.map(
              (repairOrderVehicle, index) =>
              <Fragment key={repairOrderVehicle.vehicleId}>
                  <RowHeader>
                    <HeaderItem flex={1}>
                      {repairOrderVehicle.vehicle &&
                    <Fragment>
                          {repairOrderVehicle.vehicle.vehicleModel &&
                      <span>
                              {`${
                        repairOrderVehicle.vehicle.vehicleModel.
                        brandName} `
                        }
                              {`${
                        repairOrderVehicle.vehicle.vehicleModel.name} `
                        }
                            </span>
                      }
                          <span>{repairOrderVehicle.vehicle.licensePlate}</span>
                        </Fragment>
                    }
                    </HeaderItem>
                    <HeaderItem width={27}>
                      <StyledIcon
                      type="x"
                      onClick={() => this.removeVehicle(repairOrderVehicle)} />

                    </HeaderItem>
                  </RowHeader>
                  {repairOrderVehicle.operations.map(
                  (repairOperation) =>
                  <Row key={repairOperation.operation.id} bordered>
                        <RepairOrderVehicleEditRow
                      repairOrderOperation={repairOperation}
                      onDelete={(
                      repairOrderOperation) =>

                      this.deleteOperation(
                        repairOrderVehicle.vehicleId,
                        repairOrderOperation
                      )
                      }
                      onChange={(
                      repairOrderOperation) =>

                      this.changeVehicleOperationCount(
                        repairOrderVehicle.vehicleId,
                        repairOrderOperation
                      )
                      } />

                      </Row>

                )}
                </Fragment>

            )}
            <Header>
              <HeaderItem flex={1}>ТС</HeaderItem>
              <HeaderItem flex={1}>Виды работ</HeaderItem>
              <HeaderItem width={27} />
            </Header>
            <Row className="waypoint-item">
              <RepairOrderVehicleAddRow onAdd={this.addVehicle} />
            </Row>
          </Body>
        </Table>
      </Fragment>);

  }
}

const Table = styled.div.withConfig({ displayName: "RepairOrderVehicleForm__Table", componentId: "sc-19xy1au-0" })(["width:100%;"]);



const Header = styled.div.withConfig({ displayName: "RepairOrderVehicleForm__Header", componentId: "sc-19xy1au-1" })(["background:#c0ccd7;width:100%;display:flex;font-size:14px;padding:11px 16px;"]);







const Body = styled.div.withConfig({ displayName: "RepairOrderVehicleForm__Body", componentId: "sc-19xy1au-2" })(["border:1px solid #c0ccd7;> .waypoint-item:last-child{border-bottom:0;}"]);







const HeaderItem = styled.div.withConfig({ displayName: "RepairOrderVehicleForm__HeaderItem", componentId: "sc-19xy1au-3" })(["", ";"],
(props) => css(["", ";"],
props.width ? `width: ${props.width}px;` : `flex: ${props.flex || 1};`));



export const Row = styled.div.withConfig({ displayName: "RepairOrderVehicleForm__Row", componentId: "sc-19xy1au-4" })(["padding:16px;", ";"],

(props) => props.bordered && 'border-bottom: 1px solid #e4ebf2;');


const RowHeader = styled(Header).withConfig({ displayName: "RepairOrderVehicleForm__RowHeader", componentId: "sc-19xy1au-5" })(["width:100%;background:#f0f4f8;color:#838d96;padding:11px 15px;"]);






const StyledIcon = styled(UiIcon).withConfig({ displayName: "RepairOrderVehicleForm__StyledIcon", componentId: "sc-19xy1au-6" })(["margin-top:8px;cursor:pointer;"]);




export default WashingOrderVehiclesForm;
